import React, { useState } from 'react';
import { Form } from 'semantic-ui-react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './RegisterForm.form';
import { Auth } from '../../../../api';
import './RegisterForm.scss';

const authController = new Auth();

export function RegisterForm() {
    const [error, setError] = useState("");

    const formik = useFormik({
        initialValues: initialValues(),
        validationSchema: validationSchema(),
        validateOnChange: false,
        onSubmit: async (formValue) => {
            try {
                setError("");
                console.log(formValue);
                await authController.register(formValue);
            } catch (error) {
                setError("Error into the server!!");
                console.error(error);
            }
        },
    });

  return (
    <div className='register'>
        <Form className='register__form' onSubmit={formik.handleSubmit}>
            <h1 className='register__form-h1'>Welcome.</h1>
            <p className='register__form-p'>Register here with your datas.</p>
            
            <Form.Input
                type='text'
                name='firstName'
                label='First Name'
                placeholder='first name'
                onChange={formik.handleChange}
                value={formik.values.firstName}
                error={formik.errors.firstName}
            />

            <Form.Input
                type='text'
                name='lastName'
                label='Last Name'
                placeholder='last name'
                onChange={formik.handleChange}
                value={formik.values.lastName}
                error={formik.errors.lastName}
            />

            <Form.Input
                type='text'
                name='email'
                label='Email'
                placeholder='name@company.com'
                onChange={formik.handleChange}
                value={formik.values.email}
                error={formik.errors.email}
            />

            <Form.Input
                type='password'
                name='password'
                label='Password'
                placeholder='password'
                onChange={formik.handleChange}
                value={formik.values.password}
                error={formik.errors.password}
            />

            <Form.Select
                name='role'
                label='Role'
                options={role}
                placeholder='Select'
                onChange={(_, data) => formik.setFieldValue("role", data.value)}
                value={formik.values.role}
                error={formik.errors.role}
            />

            <Form.Button className='register__form-button' type='submit' primary loading={formik.isSubmitting}>
                {'Register'}
            </Form.Button>

            <p className='register__form-p-error'>{error}</p>
        </Form>
    </div>
  );
}

const role = [
    {
        key: 'admin',
        text: 'Admin',
        value: 'ROLE_ADMIN'
    },
    {
        key: 'sales',
        text: 'Sales',
        value: 'ROLE_SALES'
    },
    {
        key: 'support',
        text: 'Support',
        value: 'ROLE_SUPPORT'
    },
]